<template>
  <div class="rounded-t-md border-b border-divider bg-white p-6">
    <span class="text-sm font-semibold text-headline">{{ label }}</span>
  </div>
</template>

<script setup lang="ts">
defineProps<{ label: string }>();
</script>
